/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { NgTemplateOutlet } from '@angular/common';
import { Component, ContentChildren, Input, QueryList, ViewEncapsulation } from '@angular/core';
import { identity } from 'lodash-es';
import { StatusOutputParamComponent } from './status-output-param/status-output-param.component';

@Component({
  selector: 'status-output',
  templateUrl: './status-output.component.html',
  styleUrls: ['./status-output.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgTemplateOutlet],
})
export class StatusOutputComponent<T> {
  @Input()
  value!: T;

  @ContentChildren(StatusOutputParamComponent) params!: QueryList<StatusOutputParamComponent<T>>;

  // Silences the NG0956 warning (https://angular.dev/errors/NG0956)
  public identity = identity;
}
